import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Route, Switch, BrowserRouter } from "react-router-dom";

import Forgot from "./pages/forgot";
import Login from "./pages/login";
import Main from "./pages/main";
import Register from "./pages/register";
import Role from "./pages/role";
import RegisterEmployee from "./pages/registerEmployee";
import QRCode from "./components/showQRCode/qrcode";
import BarCode from "./components/showQRCode/barcode";
import { isLogined } from "./utils/auth";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }
  componentDidMount() {
    this.props.getVersion();
    const { service } = this.props;
    console.log(service)
    if (isLogined()) {
      console.log("service")
      this.props.getServicesForRole();
    }
  }
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/signin" render={(props) => <Login {...props} />} />
          <Route path="/forgot" render={(props) => <Forgot {...props} />} />
          <Route path="/register" render={(props) => <Register {...props} />} />
          <Route path="/role" render={(props) => <Role {...props} />} />
          <Route
            path="/register-employee"
            render={(props) => <RegisterEmployee {...props} />}
          />
          <Route path="/qrcode" render={(props) => <QRCode {...props} />} />
          <Route path="/barcode" render={(props) => <BarCode {...props} />} />
          <Route path="/" render={(props) => <Main {...props} />} />
        </Switch>
      </BrowserRouter>
    );
  }
}
const mapState = (state) => ({
  service: state.service.service,
});

const mapDispatch = (dispatch) => ({
  checkLogin: dispatch.user.set,
  getVersion: dispatch.setting.getVersion,
  getServicesForRole: dispatch.service.getServicesForRole,
});

export default connect(mapState, mapDispatch)(translate("translations")(App));
